module.exports = __webpack_public_path__ + "media/C_level_up.f90e0d00.mp3";